module.exports = __webpack_public_path__ + "img/logo-contratacion-publica.05a4fab7.png";